import {Component, Input} from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import {
    EnumInfoUTypes,
    EnumNotificationDeliveryOptions,
    EnumPageDisplayModes,
    EnumPageEntitySources
} from '@m4u-angular/core/framework/sysenums.enum';

export class State extends BaseState {
    DeliveryOption: EnumNotificationDeliveryOptions;
    FromAddress: string;
    Address: string;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-test-dialog',
    templateUrl: './notification-test-dialog.component.html',
    styleUrls: ['./notification-test-dialog.component.scss']
})
export class NotificationTestDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() SMSEndPointIsInforU: EnumInfoUTypes;

    infoUPhonePattern: any = /^[a-zA-Z0-9\s]*$/;

    NotificationTypes = this.LIST('NotificationTypes').filter(x => x.Value !== EnumNotificationDeliveryOptions.PushMessage);

    constructor(A: ServiceBagService) {
        super(A, 'NotificationTestDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override OnInitState(): void {
        this.State.DeliveryOption = EnumNotificationDeliveryOptions.Email;
    }

    OnDeliveryOptionChange() {
        this.State.FromAddress = undefined;
        if (this.State.DeliveryOption === EnumNotificationDeliveryOptions.SMS && !this.State.FromAddress) {
            if (this.SMSEndPointIsInforU === EnumInfoUTypes.InforU) {
                this.State.FromAddress = this.RC('lblDefaultFromAddressForInforU');
            }
            else if (this.SMSEndPointIsInforU === EnumInfoUTypes.Unicell) {
                this.State.FromAddress = this.RC('lblDefaultFromAddressForUnicel');
            }
        }
    }
}
